
















import { defineComponent } from '@nuxtjs/composition-api';
import VaimoIcon from 'atoms/VaimoIcon.vue';

export default defineComponent({
  name: 'SwiperPrev',
  components: {
    VaimoIcon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Previous slide'
    },
    size: {
      type: Number,
      default: 24
    }
  },
  emits: ['navigation:click']
});
